import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export const Group = ({ group }) => {

  const { selected, updateSelected, updateAdding } = useAccessManagement2NModal();

  const onGroupClick = () => {
    updateSelected('group', group);
    updateAdding('group', false);
  };

  return (
    <div
      className={styles.groupCard}
      onClick={onGroupClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {group.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {group.Name}
        </Text>
      </div>

      <ShouldRender condition={selected.group && selected.group.Id === group.Id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
